import PrimeCarouselPagination from './PrimeCarouselPagination';
import PrimeCarousel from '@breakmedia/prime-vue-page/src/PrimeCarousel';

import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { Observable } from 'rxjs/internal/Observable';

export default PrimeCarousel.extend({
    name: 'PrimeProductCarousel',
    components: {
        PrimeCarouselPagination,
    },
    props: {
        maxDelimiters: {
            type: Number,
            default: 0,
        },
        paginator: {
            default: 'prime-carousel-pagination',
        },
    },
    data() {
        return {
            observer: null,
        };
    },
    updated() {
        const me = this;
        if (!this.observer) {
            const heightObservable = new Observable(observer => {
                this.observer = observer;
            }).pipe(debounceTime(100));
            heightObservable.subscribe({
                next(height) {
                    if (me.$el.offsetHeight != height) {
                        me.observer.next(me.$el.offsetHeight);
                    } else {
                        if (
                            me.$refs &&
                            me.$refs.paginatorReference &&
                            me.$refs.paginatorReference.setupHeight
                        ) {
                            me.$refs.paginatorReference.setupHeight(height);
                        }
                    }
                },
            });
        }
        this.observer.next(this.$el.offsetHeight);
    },
    methods: {
        genDelimiters() {
            return this.$createElement(
                'div',
                {
                    staticClass: 'v-carousel__controls' + ' ' + this.paginator,
                    style: {
                        'background-color': 'transparent',
                    },
                },
                [this.generateInlineDelimiters()],
            );
        },
        generateInlineDelimiters() {
            const items = [];
            this.items.forEach((item, i) => {
                items.push(this.getValue(item, i));
            });
            return this.$createElement(
                this.paginator,
                {
                    ref: 'paginatorReference',
                    props: {
                        length: this.maxDelimiters,
                        value: this.internalValue,
                        circle: true,
                        carouselItems: items,
                        rawItems: this.items,
                    },
                    on: {
                        input: val => {
                            this.internalValue = val;
                        },
                    },
                },
                [],
            );
        },
    },
});
